import logger from '../../services/logging/logging-service';
/**
 * Initialize Sticky player
 *
 * @param {*} players player list in page = { playerList, playerConfigList }
 */
import { VIDEO_PLAYER_OBSERVER_OPTIONS, VIDEO_PLAYER_OBSERVER_OPTIONS_MOBILE } from '../video-player/constants';
import { isWidthDeviceMobileTablet } from '../../utils/device-utils';
import { isLandscape } from '../../utils/mediaquery-utils';
import { COMMON_STATE_KEYS } from '../../global-store/subjects/common/initial-state';
import { getCommonStorePartial } from '../../global-store/subjects/common';

import {
  disableStickyElementDesktop,
  enableStickyElementDesktop,
  enableStickyElementMobile,
  disableStickyElementMobile,
  isStickyEnabled,
  disableStickyElementAttributes,
  enableStickyElementAttributes,
  createPlaceholderDiv,
  isLMPArticle,
} from './helpers';
import { initVideoPlayerListeners } from './video-player-listeners';

const $playerContainer = document.querySelector('.j-intro .o-aspect-ratio--16-9');
const $globalNav = document.querySelector('.c-global-nav');
const $sectionDividerSpecial = document.querySelector('.c-section-divider--special .c-section-divider__image');
let hasUserRejectedSticky = false;
let isTresholdPassed = false;
const INJECTED_HP_KEY = COMMON_STATE_KEYS.IS_INJECTED_HP;

// callback function for the observer
const setHasUserRejectedSticky = (value) => {
  hasUserRejectedSticky = value;
};

// without the need to use three different intersection obsverver, we can use a single one
// by dynamically changing the treshold value based on the page type
const getMobileTreshold = () => {
  switch (true) {
    case Boolean($sectionDividerSpecial) && !isLMPArticle:
      return 0.1;
    case isLMPArticle:
      return 0.6;
    default:
      return 0.3;
  }
};

export const init = (players) => {
  if (!isStickyEnabled()) {
    return;
  }

  // listener to avoid sticky player on mobile landscape
  const handleDeviceOrientation = () => {
    window.addEventListener('resize', () => {
      if (isLandscape()) {
        disableStickyElementMobile();
        disableStickyElementAttributes(players);
      } else if (!hasUserRejectedSticky && !isLandscape() && isTresholdPassed) {
        enableStickyElementMobile();
      }
    });
  };

  initVideoPlayerListeners(players, setHasUserRejectedSticky, hasUserRejectedSticky);

  if (isWidthDeviceMobileTablet()) {
    handleDeviceOrientation();

    const playerContainerObserverMobile = new IntersectionObserver((entries) => {
      entries.forEach((elem) => {
        if (isLandscape() || hasUserRejectedSticky) {
          return;
        }
        const intersectionRatioValue = getMobileTreshold();
        if (elem.intersectionRatio < intersectionRatioValue) {
          if (!isLMPArticle) {
            createPlaceholderDiv();
          }
          enableStickyElementMobile();
          enableStickyElementAttributes(players);
          isTresholdPassed = true;
        } else if (elem.intersectionRatio >= intersectionRatioValue) {
          disableStickyElementMobile();
          disableStickyElementAttributes(players);
          isTresholdPassed = false;
        }
      });
    }, VIDEO_PLAYER_OBSERVER_OPTIONS_MOBILE);

    if (isLMPArticle) {
      playerContainerObserverMobile.observe($playerContainer);
    } else {
      playerContainerObserverMobile.observe($sectionDividerSpecial || $globalNav);
    }
  } else {
    const playerContainerObserverDesktop = new IntersectionObserver((entries) => {
      const elementTreshold = isLMPArticle ? 0.5 : 0.3;
      entries.forEach((elem) => {
        if (hasUserRejectedSticky) {
          return;
        }
        if (elem.intersectionRatio < elementTreshold) {
          enableStickyElementDesktop();
          enableStickyElementAttributes(players);
        } else if (elem.intersectionRatio >= elementTreshold) {
          disableStickyElementDesktop();
          disableStickyElementAttributes(players);
        }
      });
    }, VIDEO_PLAYER_OBSERVER_OPTIONS);

    playerContainerObserverDesktop.observe($playerContainer);
  }

  // Toggle depending on the HP injected
  const isInjectedHPStore = getCommonStorePartial(INJECTED_HP_KEY);
  isInjectedHPStore.subscribe((isInjectedHP) => {
    if (isInjectedHP) {
      setHasUserRejectedSticky(true);
      disableStickyElementAttributes(players);
      if (isWidthDeviceMobileTablet()) {
        disableStickyElementMobile();
      } else {
        disableStickyElementDesktop();
      }
    }
  });
};
